import Image from 'next/image';
import Container from '@components/global/Container';
import MarkdownCopy from '@components/cms/Slices/MarkdownCopy';
import {
  HeroPLPSlice,
  ImageVariations,
} from '@adapters/prismic/types/brandedStorePage';

import styles from './HeroPLP.module.scss';
import Heading from '@components/ui/Heading';
import YouTubeEmbed from '@components/cms/Slices/MediaEmbed/YouTubeEmbed';
import PrismicImage from '@components/cms/PrismicImage';

export const HeroPLP = ({ primary }: HeroPLPSlice) => {
  return (
    <div id={primary?.id}>
      {primary?.background_image &&
      primary?.image_variations &&
      primary?.image_variations === ImageVariations.image ? (
        <div className={styles.mediaContainer}>
          {primary.logo && (
            <div className={styles.logoContainer}>
              <Image
                src={primary.logo?.url}
                alt={primary.logo?.alt || ''}
                fill
                sizes="100vw"
                style={{
                  objectFit: 'contain',
                }}
              />
            </div>
          )}
          <div className={styles.bannerImageContainer}>
            <div className={styles.bannerImage}>
              <PrismicImage
                src={primary.background_image?.url}
                alt={primary.background_image?.alt ?? ''}
                layout="responsive"
                priority
                width={primary.background_image?.dimensions?.width}
                height={primary.background_image?.dimensions.height}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.videoContainer}>
          {primary.logo && (
            <div className={styles.logoContainer}>
              <Image
                src={primary.logo?.url}
                alt={primary.logo?.alt || ''}
                fill
                sizes="100vw"
                style={{
                  objectFit: 'contain',
                }}
              />
            </div>
          )}
          <YouTubeEmbed
            html={`<iframe width="100%" height="100%" src="https://www.youtube.com/embed/${primary?.video_id}?feature=oembed&enablejsapi=1&controls=0&autoplay=1&mute=1&loop=1&playsinline=1&modestbranding=1&rel=0&autohide=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`}
          />
        </div>
      )}
      <Container className={styles.contentContainer}>
        <Heading semanticLevel="h1" styleLevel="1" className={styles.heading}>
          {primary.title}
        </Heading>
        {primary?.copy?.[0]?.text && (
          <MarkdownCopy
            text={primary?.copy?.[0]?.text ?? ''}
            className={styles.copy}
          />
        )}
      </Container>
    </div>
  );
};

export default HeroPLP;
